export default __webpack_public_path__ + "static/media/longchamp21.e96af109.jpg";